import type { RequestLog } from '@engine/models'

import { adminFetch } from '#api/client.js'

import { CopyRequestButton } from './CopyRequestButton'

const LABELS: Record<string, string> = {
  document: 'Copy Document Request',
  rates: 'Copy Quote Request',
  shipment: 'Copy eBOL Request',
  tender: 'Copy Tender Request',
  track: 'Copy Tracking Request',
}

interface CopyServiceRequestButtonProps {
  log: RequestLog
}

/**
 * Copies the payload the engine would send to the microservice that owns this
 * request type, re-mapped from the logged tenant request.
 */
export const CopyServiceRequestButton = ({
  log,
}: CopyServiceRequestButtonProps) => (
  <CopyRequestButton
    label={LABELS[log.type] || 'Copy Service Request'}
    getContent={() =>
      adminFetch('service-request', {
        method: 'POST',
        json: {
          ...log.tenantRequest.content,
          type: log.type,
          tenantId: log.tenantId,
          requestId: log.requestId,
        },
      })
    }
  />
)
